<script lang="ts">
	import PlatformToggle from '../../../../containers/PlatformToggleButton.svelte';
	import { createEventDispatcher } from 'svelte';

	let dispatch = createEventDispatcher();
	function dispatchDeleted() {
		dispatch('refresh');
	}

	export let row: any;
</script>

<PlatformToggle
  id={row.id}
  traitID={row.externalId}
  name={row.name}
  isActive={row.sendToPlatform}
  platformLabel={row.platformLabel}
  on:dispatchSuccess={dispatchDeleted}
/>
